<div class="auth-container">
  <!-- Main Content Card -->
  <div class="main-card">
    <!-- Branding Header -->
    <div class="branding-header">
      <div class="logo-container">
        <img src="https://supersee.io/wp-content/uploads/2025/02/Supersee_Logo-1.webp" alt="SuperSee Logo" class="logo">
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-section">
      <div class="loading-container">
        <div class="spinner-wrapper">
          <div class="spinner-ring spinner-ring-1"></div>
          <div class="spinner-ring spinner-ring-2"></div>
          <div class="spinner-ring spinner-ring-3"></div>
          <div class="spinner-center">
            <div class="spinner-dot"></div>
          </div>
        </div>
      </div>

      <h2 class="loading-text">Signing You In</h2>
      <p class="loading-subtext">Please wait while we securely connect to your account</p>

      <!-- Loading Steps -->
      <div class="loading-steps">
        <div *ngFor="let step of loadingSteps; let i = index" 
             class="step-item"
             [class.completed]="step.completed"
             [class.active]="i === currentStepIndex && !step.completed"
             [class.pending]="i > currentStepIndex">
          <div class="step-icon">
            <span *ngIf="step.completed" class="check-icon">✓</span>
            <span *ngIf="!step.completed" class="step-emoji">{{ step.icon }}</span>
          </div>
          <span class="step-text">{{ step.text }}</span>
          <div *ngIf="i === currentStepIndex && !step.completed" class="step-loader">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </div>

      <div class="progress-indicator">
        <div class="progress-bar">
          <div class="progress-fill" [style.animation-duration]="'6s'"></div>
        </div>
      </div>
    </div>

    <!-- Mobile Onboarding Warning -->
    <div class="flex w-full flex-col items-center mt-2 pb-10 px-4 text-center" *ngIf="isMobileOnboardingWarning" style="display: flex; flex-direction: column; align-items: center; text-align: center; padding: 20px 16px 40px;">
        <!-- Icon -->
        <div class="w-16 h-16 rounded-2xl bg-[#5459d1]/10 flex items-center justify-center mx-auto mb-6" style="width: 64px; height: 64px; border-radius: 1rem; background-color: rgba(84, 89, 209, 0.1); display: flex; align-items: center; justify-content: center; margin: 0 auto 24px;">
            <span class="material-symbols-outlined text-[#5459d1] text-[32px]" style="color: #5459d1; font-size: 32px;">desktop_windows</span>
        </div>

        <h1 class="text-2xl font-bold text-[#393939] text-center m-0 mb-3" style="font-size: 1.5rem; font-weight: bold; color: #393939; margin: 0 0 12px 0;">Continue setup on your desktop or laptop</h1>
        <p class="text-gray-500 text-center text-[15px] m-0 mb-8 max-w-[320px] mx-auto leading-relaxed" style="color: #6b7280; font-size: 15px; margin: 0 auto 32px; max-width: 320px; line-height: 1.625;">
            You've opened your setup link on a mobile device. To install the SuperSee agent and complete onboarding, please open this same link on a desktop or laptop.
        </p>
    </div>

  </div>
</div>